import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import _slicedToArray from "@babel/runtime-corejs2/helpers/slicedToArray";
import React from 'react';
import PropTypes from 'prop-types';
import { Input as CustomInput } from '@dmi-mch/components';
import AWS from 'aws-sdk';
import { IconClip } from '@dmi-mch/icons';

var FileUploader = function FileUploader(_ref) {
  var configurationS3 = _ref.configurationS3,
      setFieldValue = _ref.setFieldValue,
      pathToNewFile = _ref.pathToNewFile,
      nameForNewFile = _ref.nameForNewFile,
      disabled = _ref.disabled,
      _ref$acceptedFileForm = _ref.acceptedFileFormats,
      acceptedFileFormats = _ref$acceptedFileForm === void 0 ? '' : _ref$acceptedFileForm,
      _ref$onFileSelected = _ref.onFileSelected,
      onFileSelected = _ref$onFileSelected === void 0 ? function () {} : _ref$onFileSelected;

  var _React$useState = React.useState(null),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filename = _React$useState2[0],
      setFilename = _React$useState2[1];

  var _React$useState3 = React.useState(null),
      _React$useState4 = _slicedToArray(_React$useState3, 2),
      isUploading = _React$useState4[0],
      setIsUploading = _React$useState4[1];

  var _React$useState5 = React.useState(null),
      _React$useState6 = _slicedToArray(_React$useState5, 2),
      httpUploadProgress = _React$useState6[0],
      setHttpUploadProgress = _React$useState6[1];

  React.useEffect(function () {
    if (disabled) {
      setFilename('');
    }
  }, [disabled]); // Configuring AWS

  AWS.config.update({
    region: configurationS3.bucketRegion,
    credentials: new AWS.CognitoIdentityCredentials({
      IdentityPoolId: configurationS3.identityPoolId
    })
  });
  var s3 = new AWS.S3({
    apiVersion: configurationS3.apiVersion,
    params: {
      Bucket: configurationS3.bucketName
    }
  });

  var fileSelected = function fileSelected(e) {
    setIsUploading(true);
    onFileSelected(e);

    var _document$getElementB = document.getElementById('fileUpload'),
        files = _document$getElementB.files;

    if (files) {
      var file = files[0];
      var fileExtension = file.name.split('.').pop();
      var filePath = "".concat(pathToNewFile, "/").concat(nameForNewFile, ".").concat(fileExtension);
      var fileUrl = "https://".concat(configurationS3.bucketName, ".s3.").concat(configurationS3.bucketRegion, ".amazonaws.com/").concat(filePath);
      s3.upload({
        Key: filePath,
        Body: file,
        ACL: 'public-read'
      }, function (err) {
        if (err) {
          setIsUploading(false);
        }

        setFilename(fileUrl);
        setFieldValue('url', fileUrl);
        setIsUploading(false);
        return fileUrl;
      }).on('httpUploadProgress', function (progress) {
        setHttpUploadProgress(_parseInt(progress.loaded * 100 / progress.total, 0));
      });
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, isUploading ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("progress", {
    max: "100",
    value: httpUploadProgress
  })) : /*#__PURE__*/React.createElement(CustomInput, {
    type: "text",
    name: "url",
    value: !disabled && filename ? filename : '',
    readOnly: true,
    icon: /*#__PURE__*/React.createElement(IconClip, null),
    onClick: function onClick() {
      return document.getElementById('fileUpload').click();
    },
    placeholder: "Click here to select a file",
    disabled: disabled
  }), /*#__PURE__*/React.createElement("input", {
    id: "fileUpload",
    style: {
      visibility: 'hidden',
      position: 'absolute'
    },
    type: "file",
    onChange: fileSelected,
    accept: acceptedFileFormats
  }));
};

FileUploader.propTypes = {
  onFileSelected: PropTypes.func,
  className: PropTypes.string,
  pathToNewFile: PropTypes.string,
  nameForNewFile: PropTypes.string,
  setFieldValue: PropTypes.func,
  configurationS3: PropTypes.object,
  disabled: PropTypes.bool,
  acceptedFileFormats: PropTypes.string
};
export default FileUploader;